import {ThreeThirdPersonHandler} from "./device_third_person";
import TouchControls from "../camera_controls/touch_controls/TouchControls";

export class ThreeMobileHandler extends ThreeThirdPersonHandler {

	touchControls

	//@override
	bindControls(camera, domElement, scene) {
		super.bindControls(camera,domElement,scene)

		this.touchControls = new TouchControls(camera, domElement)

		this.touchControls.containerElement.addEventListener('change', (e) => {
			this.collisionHandler.setMovementDirection(e.detail)
		})

		this.touchControls.containerElement.addEventListener('wheel', (e) => {
			this.collisionHandler.zoom(e.detail)
		})

		return this.deviceControls;
	}
}
